var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12872",
    "data-name": "Group 12872",
    transform: "translate(1143.95 -864.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6342",
    "data-name": "Line 6342",
    y2: 39,
    transform: "translate(866.5 1104.95)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6343",
    "data-name": "Line 6343",
    y2: 21,
    transform: "translate(888.5 1122.95)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6344",
    "data-name": "Line 6344",
    y2: 21,
    transform: "translate(910.5 1122.95)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationIcon);
export default __webpack_public_path__ + "static/media/pagination-icon.2c269542e7e297b51fbaf216a6d8902e.svg";
export { ForwardRef as ReactComponent };